import { createRouter, ErrorComponentProps } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { queryClient } from '@/lib/queryClient.ts';
import { QueryClient } from '@tanstack/react-query';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay.tsx';
import { Trans } from '@lingui/react/macro';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

// eslint-disable-next-line react-refresh/only-export-components
const ErrorComponent = (props: ErrorComponentProps) => (
  <ErrorDisplay
    message={props.error.message}
    actions={
      <Button
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={() => window.location.reload()}
      >
        <Trans>Reload page</Trans>
      </Button>
    }
  />
);

export interface AppRouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultErrorComponent: ErrorComponent,
  defaultPendingMs: 700,
  notFoundMode: 'root',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
